import { Modal } from 'react-bootstrap';

import { Button } from 'Components/Buttons/Buttons';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { ModalHeader } from 'Components/Modal/ModalHeader';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';
import { getUserNameFromUser, sortFormattedUsers } from 'Helpers/UserUtils';

import styles from './UsersModal.module.css';

export interface UsersModalProps {
    header: string;
    hideModal: () => void;
    userIds: string[];
}

export const UsersModal = (props: UsersModalProps) => {
    const cachedData = useCachedData();

    return (
        <Modal show size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className="modalFromBody">
                <ModalHeader text={props.header} />
                {sortFormattedUsers([...props.userIds.map((userId) => cachedData.users.find((user) => user.cognito_subject === userId)!)]).map((user) => {
                    const userName = getUserNameFromUser(user);

                    return (
                        <div key={user.cognito_subject} className={styles.attributeGroup}>
                            <div className={styles.attributeName}>
                                <Text noStyles>{userName}</Text>
                            </div>
                            <div className={styles.attributeEmail}>
                                <Text noStyles>{user.email_address}</Text>
                            </div>
                        </div>
                    );
                })}
                <div className={'modalFormButtonContainer'}>
                    <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
